import React, { useState } from 'react'
import Headerone from '../headerone/newMain'
import Bredcom from '../Bredcom/Main'

function EqualOpportunityCell() {
    return (
        <>
            <Headerone />
            <Bredcom title="Home" subtitle="Equal Opportunity Cell" />
            <section className="about-area about-p pt-120 pb-120 p-relative fix">
                <div className="animations-02">
                    <img src="/assets/img/bg/an-img-02.png" alt="contact-bg-an-01" />
                </div>
                <div className="container">
                    <div className="row justify-content-center align-items-center">                        
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                <div className="about-title second-title pb-25">                                    
                                    <h3>EQUAL OPPORTUNITY CELL (EОС)</h3>
                                </div>
                                <p>
                                In accordance with the guidelines of the University Grants Commission (UGC), the Hon'ble
Vice Chancellor of MVN University has constituted the Equal Opportunity Cell (EOC). The
primary objective of this cell is to address issues related to students belonging to Scheduled
Castes (SC), Scheduled Tribes (ST), Other Backward Classes (OBC), Minorities, and Persons
Disabilities (PWDs). The EOC aims to empower these students, ensuring their
participation in the academic, intellectual, social, and cultural life of the University on an
with
equal basis.
                                </p>
                            
                                <p><b>The Equal Opportunity Cell comprises the following members:</b></p>
                                <div className='table'>
                                    <table className='table table-bordered'>
                                        <thead className='table-light head_red'>
                                            <tr>
                                                <th>Sr. No</th>
                                                <th>Name</th>
                                                <th>Designation in University</th>
                                                <th>Role in EОС</th>
                                                <th>Mobile No.</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>1.</td>
                                                <td>Dr. Yogendra Singh</td>
                                                <td>Registrar</td>
                                                <td>Coordinator/ Convener</td>
                                                <td>8814822240/ 9414494181</td>
                                            </tr>
                                            <tr>
                                                <td>2.</td>
                                                <td>Dr. Shrivardhan Dheeman</td>
                                                <td>Dy. Director, IQAC</td>
                                                <td>Member</td>
                                                <td>88958242871</td>
                                            </tr>
                                            <tr>
                                                <td>3.</td>
                                                <td>Ms. Ritika Jaggi</td>
                                                <td>Assistant Professor, School of Allied Health Sciences</td>
                                                <td>Representative (SC & ST)</td>
                                                <td>9650892018</td>
                                            </tr>
                                            <tr>
                                                <td>4.</td>
                                                <td>Mr. Sumit</td>
                                                <td>Assistant Professor, School of Engineering & Technology</td>
                                                <td>Representative (SC & ST)</td>
                                                <td>8708408902</td>
                                            </tr>
                                            <tr>
                                                <td>5.</td>
                                                <td>Mr. Daya Shankar Prasad</td>
                                                <td>Assistant Professor, School of Engineering & Technology</td>
                                                <td>Representative (OBC)</td>
                                                <td>9572658282</td>
                                            </tr>
                                            <tr>
                                                <td>6.</td>
                                                <td>Mohd. Isfaq</td>
                                                <td>Assistant Professor, School of Pharmaceutical Sciences</td>
                                                <td>Representative (Religious and language minorities)</td>
                                                <td>7015974288/ 8950400000</td>
                                            </tr>
                                            <tr>
                                                <td>7.</td>
                                                <td>Dr. Ramveer Singh</td>
                                                <td>Associate Professor, School of Law</td>
                                                <td>Representative (General, PWD & EWS)</td>
                                                <td>9968795577</td>
                                            </tr>
                                            <tr>
                                                <td>8.</td>
                                                <td>Rohit (24SL4007)</td>
                                                <td>Student Representative</td>
                                                <td>Member</td>
                                                <td>9350627069</td>
                                            </tr>
                                            <tr>
                                                <td>9.</td>
                                                <td>Shahbaj Ansari (23BS/ML/1012)</td>
                                                <td>Student Representative</td>
                                                <td>Member</td>
                                                <td>9506254645</td>
                                            </tr>
                                            <tr>
                                                <td>10.</td>
                                                <td>Dr. Rahul Varshney </td>
                                                <td>Dean, Student Welfare</td>
                                                <td>Member Secretary</td>
                                                <td>7617626555</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <p>The tenure of the committee members will be two years from the date of this notification.
This order supersedes all previous notifications, circulars, or office orders issued on this
subject.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default EqualOpportunityCell